import alt from '../alt';
import leaveSetAction from '../actions/leaveSetAction';

class leaveSetStore {
    constructor() {
        this.bindActions(leaveSetAction);
        this.search = "";
        this.leaves = []
        this.processing = false;
        this.staffId = "";
        this.userName = "";
        this.maxBringFwd = 0;
        this.updating = false;
        this.isSucceed = false;
        this.holiday = { };
        this.isHolidayUpdated = false;
    }

    onSearch(data) {
        this.search = data;
    }
    onProcessing(data) {
        this.processing = data;
    }
    onStaffId(data) {
        this.staffId = data;
    }
    onHoliday(data){
        this.holiday = data;
    }
    onIsHolidayUpdated(data){
        this.isHolidayUpdated = data;
    }
    onUserName(data) {
        this.userName = data;
    }
    onUpdating(data) {
        this.updating = data;
    }
    onLeaveTotalSuccess(data) {
        this.leaves = data;
    }
    onTotalGain(data) {
        let len = this.leaves.length;
        for (let i = 0; i < len; i++) {
            if (this.leaves[i].type == data.type) {
                this.leaves[i].totalGain = data.value;
                break;
            }
        }
    }
    onUsed(data) {
        let len = this.leaves.length;
        for (let i = 0; i < len; i++) {
            if (this.leaves[i].type == data.type) {
                this.leaves[i].used = data.value;
                break;
            }
        }
    }
    onBringFwd(data) {
        let len = this.leaves.length;
        for (let i = 0; i < len; i++) {
            if (this.leaves[i].type == data.type) {
                this.leaves[i].bringFwd = data.value;
                break;
            }
        }
    }
    onIsSucceed(data) {
        this.isSucceed = data;
    }
    onUpdateLvTotalSuccess(data) {
        this.isSucceed = true;
    }
    onRemoveLeaveSuccess(data) {
        let len = this.leaves.length;
        for (let i = 0; i < len; i++) {
            if (this.leaves[i].type == data) {
                this.leaves.splice(i, 1);
            }
        }
    }
    onAddLeaveSuccess(data) {
        this.leaves = this.leaves.concat(data);
    }
    onMaxBringFwd(data) {
        this.maxBringFwd = data;
    }
    onLeaveGain(data) {
        let len = this.leaves.length;
        for (let i = 0; i < len; i++) {
            if (this.leaves[i].type == data.type) {
                this.leaves[i].leaveGain = data.value;
                break;
            }
        }
    }
}
export default alt.createStore(leaveSetStore, 'leaveSetStore');


// WEBPACK FOOTER //
// ./app/stores/leaveSetStore.js